import { API_ENDPOINT_CSL_PLASMA } from "../../config/api";

const SubmitIframe = ({title, number, formLink, isDevice, data}) => {

    return <>
        <iframe className="w-100 h-100" style={{ backgroundColor: 'white' }} src={`${API_ENDPOINT_CSL_PLASMA}/ShareFormPage?isView=show&title=${title}&number=${number}&isDevice=${isDevice}`} title={`${title}`}></iframe>
    </>
}
export default SubmitIframe;